import { useContext } from 'react';
import { LobTypeContext } from '@/components/lob-templates/context';

export function useLobType() {
  const [lobTypeId, dispatch] = useContext(LobTypeContext);

  return [lobTypeId, dispatch];
}
